import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'aza-rws-toggle-button',
    templateUrl: 'toggle-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule]
})
export class ToggleButtonComponent implements OnInit {
    @Input() text?: string;
    @Input() toggledText: string;
    @Input() toggledClassNames = '';
    @Input() notToggledText: string;
    @Input() notToggledClassNames = '';
    @Input() classNames = '';
    @Output() toggledChanged = new EventEmitter<boolean>();

    toggled = false;
    stateClassNames = '';

    ngOnInit(): void {
        this.stateClassNames = this.createStateClassNames(this.toggled);
    }

    onToggled(): void {
        this.toggled = !this.toggled;
        this.stateClassNames = this.createStateClassNames(this.toggled);
        this.toggledChanged.emit(this.toggled);
    }

    private createStateClassNames(toggled: boolean): string {
        const stateClassNames = toggled ? this.toggledClassNames : this.notToggledClassNames;
        return `aza-rws-toggle-button ${this.classNames} ${stateClassNames}`;
    }
}
